export default __webpack_public_path__ + "static/media/transaction-success-img.484aca38.png";